import React from 'react';
import { Target, Globe, Zap } from 'lucide-react';

export const About = () => {
  const features = [
    {
      icon: Target,
      title: 'Measurable Impact',
      description: 'Delivering immersive experiences and scalable platforms'
    },
    {
      icon: Zap,
      title: 'Innovation & Execution',
      description: 'Operating at the intersection of advanced technology and practical solutions'
    },
    {
      icon: Globe,
      title: 'Global Excellence',
      description: 'Built in Saudi Arabia, designed to serve the world'
    }
  ];

  return (
    <section id="about" className="py-16 md:py-32 relative overflow-hidden">
      {/* Background gradient accent */}
      <div className="absolute top-0 right-0 w-1/3 h-1/3 bg-[#5B42FF]/5 rounded-full blur-3xl"></div>
      
      <div className="max-w-7xl mx-auto px-4 md:px-6 relative">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-xs md:text-sm font-semibold text-[#5B42FF] uppercase tracking-wider mb-3 md:mb-4">About RevoTech</h2>
          <h3 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 md:mb-6">Transforming Vision Into Reality</h3>
          <div className="w-20 md:w-24 h-1 bg-[#5B42FF] mx-auto"></div>
        </div>

        <div className="max-w-4xl mx-auto px-4">
          <p className="text-lg md:text-xl text-white/80 leading-relaxed mb-6 md:mb-8 text-center">
            We deliver measurable impact through immersive experiences and scalable platforms for government, semi-government, and private-sector organizations.
          </p>
          <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8 md:mb-12 text-center">
            Headquartered in Riyadh, we operate at the intersection of innovation, experience, and execution. Our focus is on transforming advanced technologies into practical, high-value solutions that support digital transformation, service excellence, and long-term growth.
          </p>
        </div>

        {/* Feature Cards */}
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 mt-12 md:mt-16">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group p-6 md:p-8 bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl md:rounded-2xl hover:border-[#5B42FF]/50 transition-all duration-300 hover:transform hover:scale-105 hover:bg-white/10"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 bg-[#5B42FF]/20 rounded-xl flex items-center justify-center mb-4 md:mb-6 group-hover:bg-[#5B42FF]/30 transition-colors duration-300">
                <feature.icon className="w-6 h-6 md:w-7 md:h-7 text-[#5B42FF]" />
              </div>
              <h4 className="text-lg md:text-xl font-semibold text-white mb-2 md:mb-3">{feature.title}</h4>
              <p className="text-sm md:text-base text-white/70">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Bottom accent */}
        <div className="mt-12 md:mt-16 text-center">
          <div className="inline-block px-4 md:px-6 py-2 md:py-3 bg-[#5B42FF]/10 border border-[#5B42FF]/30 rounded-full">
            <p className="text-sm md:text-base text-white/90 font-medium">Built in Saudi Arabia. Designed to serve the world.</p>
          </div>
        </div>
      </div>
    </section>
  );
};